(function () {
  function initOurProducts(root) {
    if (!root || root.dataset.productsReady === 'true') return;

    var grids = Array.prototype.slice.call(root.querySelectorAll('[data-products-grid]'));
    var categorySections = Array.prototype.slice.call(root.querySelectorAll('[data-products-category-section]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-products-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-products-card]'));
    var categoryLinks = Array.prototype.slice.call(root.querySelectorAll('.our-products__category-link'));
    var empty = root.querySelector('[data-products-empty]');
    var sortSelect = root.querySelector('[data-products-sort]');
    var toolbar = root.querySelector('[data-products-toolbar]');
    var advancedFilters = root.querySelector('[data-products-advanced-filters]');
    var openPanelButton = root.querySelector('[data-products-panel-open]');
    var closePanelButtons = Array.prototype.slice.call(root.querySelectorAll('[data-products-panel-close]'));
    var toolbarBackdrop = root.querySelector('.our-products__toolbar-backdrop');
    var activeTags = [];

    if (!grids.length || !cards.length) return;

    root.dataset.productsReady = 'true';

    function compareText(a, b, key) {
      return (a.dataset[key] || '').localeCompare(b.dataset[key] || '', undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    }

    function sortCards(mode) {
      grids.forEach(function (grid) {
        var sortedCards = Array.prototype.slice.call(grid.querySelectorAll('[data-products-card]'));

        sortedCards.sort(function (a, b) {
          if (mode === 'title-asc') return compareText(a, b, 'title');
          if (mode === 'title-desc') return compareText(b, a, 'title');
          if (mode === 'category-asc') return compareText(a, b, 'category') || compareText(a, b, 'title');
          return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
        });

        sortedCards.forEach(function (card) {
          grid.appendChild(card);
        });
      });
    }

    function renderProducts() {
      var visibleCount = 0;
      var sortMode = sortSelect ? sortSelect.value : 'manual';

      sortCards(sortMode);

      cards.forEach(function (card) {
        var cardTags = (card.dataset.tags || '').split(' ').filter(Boolean);
        var shouldShow = !activeTags.length || activeTags.some(function (tag) {
          return cardTags.indexOf(tag) !== -1;
        });

        card.classList.toggle('is-hidden', !shouldShow);
        card.toggleAttribute('hidden', !shouldShow);

        if (shouldShow) visibleCount += 1;
      });

      categorySections.forEach(function (section) {
        var hasVisibleCards = Boolean(section.querySelector('[data-products-card]:not([hidden])'));

        section.classList.toggle('is-hidden', !hasVisibleCards);
        section.toggleAttribute('hidden', !hasVisibleCards);
      });

      var activeCategoryLink = categoryLinks.find(function (link) {
        return link.classList.contains('is-active');
      });
      var activeCategorySection = activeCategoryLink ? root.querySelector(activeCategoryLink.getAttribute('href')) : null;

      if (!activeCategorySection || activeCategorySection.hidden) {
        var firstVisibleSection = categorySections.find(function (section) {
          return !section.hidden;
        });
        var firstVisibleLink = firstVisibleSection && categoryLinks.find(function (link) {
          return link.getAttribute('href') === '#' + firstVisibleSection.id;
        });

        if (firstVisibleLink) setActiveCategory(firstVisibleLink);
      }

      buttons.forEach(function (button) {
        var filter = button.dataset.productsFilter || 'all';
        var isPressed = filter === 'all' ? !activeTags.length : activeTags.indexOf(filter) !== -1;

        button.setAttribute('aria-pressed', isPressed ? 'true' : 'false');
      });

      if (empty) empty.hidden = visibleCount !== 0;
    }

    function setPanelOpen(isOpen) {
      root.classList.toggle('is-filter-panel-open', isOpen);

      if (isOpen && advancedFilters && window.matchMedia('(max-width: 989px)').matches) {
        advancedFilters.open = true;
      }

      if (toolbar) toolbar.classList.toggle('is-open', isOpen);
      if (openPanelButton) openPanelButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (toolbarBackdrop) toolbarBackdrop.hidden = !isOpen;

      document.documentElement.classList.toggle('our-products-panel-open', isOpen);
    }

    function closePanel() {
      setPanelOpen(false);
    }

    function setActiveCategory(link) {
      categoryLinks.forEach(function (categoryLink) {
        var isActive = categoryLink === link;

        categoryLink.classList.toggle('is-active', isActive);
        if (isActive) {
          categoryLink.setAttribute('aria-current', 'true');
        } else {
          categoryLink.removeAttribute('aria-current');
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.dataset.productsFilter || 'all';

        if (filter === 'all') {
          activeTags = [];
        } else if (activeTags.indexOf(filter) === -1) {
          activeTags.push(filter);
        } else {
          activeTags = activeTags.filter(function (tag) {
            return tag !== filter;
          });
        }

        renderProducts();
      });
    });

    categoryLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        setActiveCategory(link);
        closePanel();
      });
    });

    if (openPanelButton) {
      openPanelButton.addEventListener('click', function () {
        setPanelOpen(!root.classList.contains('is-filter-panel-open'));
      });
    }

    closePanelButtons.forEach(function (button) {
      button.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', renderProducts);
    }

    if ('IntersectionObserver' in window && categoryLinks.length && categorySections.length) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var activeLink = categoryLinks.find(function (link) {
            return link.getAttribute('href') === '#' + entry.target.id;
          });

          if (activeLink) setActiveCategory(activeLink);
        });
      }, {
        rootMargin: '-35% 0px -55% 0px',
        threshold: 0
      });

      categorySections.forEach(function (section) {
        sectionObserver.observe(section);
      });
    } else if (categoryLinks.length) {
      setActiveCategory(categoryLinks[0]);
    }

    renderProducts();
  }

  function initAll() {
    document.querySelectorAll('[data-our-products]').forEach(initOurProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initOurProducts(event.target.querySelector('[data-our-products]'));
  });
})();
